import React, { useState } from "react";
import { TermsOfServicePage } from "../pages/consent/TermsOfServicePage";
import { PrivacyPolicyPage } from "../pages/consent/PrivacyPolicyPage";
import Link from "@carrier-io/air-react/Link";
import Box from "@carrier-io/air-react/Box";
import { Modal, Typography } from "@carrier-io/air-react";
import IconButton from "@carrier-io/air-react/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const StyledLink = ({ children, onClick, ...otherProps }) => {
  return (
    <Link
      variant="body2"
      component="button"
      sx={{
        textDecoration: "none",
      }}
      onClick={onClick}
      {...otherProps}
    >
      {children}
    </Link>
  );
};

const StyledBox = ({ children, onClose, title }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        maxWidth: "80%",
        maxHeight: "80%",
        overflow: "auto",
      }}
    >
      <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
        {title}
      </Typography>
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      {children}
    </Box>
  );
};

export const CustomTerms = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <StyledLink onClick={handleOpen}>Terms of Service</StyledLink>
      <Modal open={open} onClose={handleClose}>
        <StyledBox onClose={handleClose} title="Terms of Service">
          <TermsOfServicePage />
        </StyledBox>
      </Modal>
    </>
  );
};

export const CustomPolicy = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <StyledLink onClick={handleOpen}>Privacy Policy</StyledLink>
      <Modal open={open} onClose={handleClose}>
        <StyledBox onClose={handleClose} title="Privacy Policy">
          <PrivacyPolicyPage />
        </StyledBox>
      </Modal>
    </>
  );
};
